module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.protocolTypeList.length > 0) ? _c('div', [_c('content-block', {
    attrs: {
      "title": "是否关联补充协议",
      "isRequired": ""
    }
  }, [_c('div', [_c('label', {
    attrs: {
      "for": "connectProtocol1"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.connectProtocol),
      expression: "connectProtocol"
    }],
    attrs: {
      "id": "connectProtocol1",
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.connectProtocol, true)
    },
    on: {
      "change": function($event) {
        _vm.changeConnect()
      },
      "__c": function($event) {
        _vm.connectProtocol = true
      }
    }
  }), _vm._v(" 是")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "connectProtocol2"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.connectProtocol),
      expression: "connectProtocol"
    }],
    attrs: {
      "id": "connectProtocol2",
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.connectProtocol, false)
    },
    on: {
      "change": function($event) {
        _vm.changeConnect()
      },
      "__c": function($event) {
        _vm.connectProtocol = false
      }
    }
  }), _vm._v(" 否")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validateErrors.has('tab1', 'model.supplierProtocolRule')),
      expression: "validateErrors.has('tab1','model.supplierProtocolRule')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("请补充完整下方所需关联协议")])]), _vm._v(" "), (_vm.connectProtocol) ? _c('content-block', {
    attrs: {
      "title": "关联协议",
      "isRequired": ""
    }
  }, _vm._l((_vm.selectProtocolTypeList), function(block, index) {
    return _c('div', [_c('div', {
      staticStyle: {
        "position": "relative"
      }
    }, [_c('div', {
      staticClass: "step-line"
    }), _vm._v(" "), _c('div', {
      staticClass: "row step-content"
    }, [_c('div', {
      staticClass: "ticket-step ticket-step-active col-sm-1"
    }, [_vm._v("1")]), _vm._v(" "), _c('span', {
      staticClass: "col-sm-1 no-padding-right"
    }, [_vm._v("协议类型")]), _vm._v(" "), (_vm.protocolTypeList.length > 1) ? _c('v-select', {
      staticClass: "col-sm-6",
      attrs: {
        "placeholder": "请选择协议类型"
      },
      model: {
        value: (_vm.selectProtocolTypeList[index]),
        callback: function($$v) {
          _vm.$set(_vm.selectProtocolTypeList, index, $$v)
        },
        expression: "selectProtocolTypeList[index]"
      }
    }, _vm._l((_vm.protocolTypeList), function(item) {
      return _c('v-option', {
        key: item.key,
        attrs: {
          "label": item.name,
          "value": item.key,
          "disabled": _vm.selectProtocolTypeList.indexOf(item.key) !== -1
        }
      })
    })) : (_vm.protocolTypeList.length === 1) ? _c('span', {
      staticClass: "col-sm-6"
    }, [_vm._v(_vm._s(_vm.protocolTypeList[0].name))]) : _vm._e(), _vm._v(" "), _c('span', [(_vm.selectProtocolTypeList.length < _vm.protocolTypeList.length) ? _c('button', {
      staticClass: "btn btn-link btn-xs",
      on: {
        "click": function($event) {
          _vm.addProtocolType()
        }
      }
    }, [_c('i', {
      staticClass: "icon-button icon-plus"
    })]) : _vm._e(), _vm._v(" "), (_vm.selectProtocolTypeList.length > 1) ? _c('button', {
      staticClass: "btn btn-link btn-xs",
      on: {
        "click": function($event) {
          _vm.removeProtocolType(index)
        }
      }
    }, [_c('i', {
      staticClass: "icon-button delete icon-cancel"
    })]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
      staticClass: "row step-content"
    }, [_c('div', {
      staticClass: "ticket-step ticket-step-active col-sm-1"
    }, [_vm._v("2")]), _vm._v(" "), _c('span', {
      staticClass: "col-sm-1 no-padding-right"
    }, [_vm._v("协议名称")]), _vm._v(" "), (_vm.selectProtocolTypeList[index] === '') ? _c('v-input', {
      staticClass: "col-sm-6",
      attrs: {
        "disabled": true
      }
    }) : (_vm.protocolInfo[_vm.selectProtocolTypeList[index]].length === 1) ? _c('span', {
      staticClass: "col-sm-6"
    }, [_vm._v(_vm._s(_vm.protocolInfo[_vm.selectProtocolTypeList[index]][0].ruleName))]) : (_vm.protocolInfo[_vm.selectProtocolTypeList[index]].length > 1) ? _c('v-select', {
      staticClass: "col-sm-6",
      attrs: {
        "placeholder": "请选择协议名称"
      },
      on: {
        "change": _vm.addProtocol
      },
      model: {
        value: (_vm.tempMsg),
        callback: function($$v) {
          _vm.tempMsg = $$v
        },
        expression: "tempMsg"
      }
    }, _vm._l((_vm.protocolInfo[_vm.selectProtocolTypeList[index]]), function(item) {
      return _c('v-option', {
        key: item.ruleId,
        attrs: {
          "label": item.ruleName,
          "value": ((_vm.selectProtocolTypeList[index]) + "~||~" + (JSON.stringify(item))),
          "disabled": typeof item.disabled !== 'undefined' && item.disabled
        }
      })
    })) : _vm._e()], 1)]), _vm._v(" "), (_vm.selectProtocolTypeList[index] !== '' &&
      _vm.supplierProtocolRule[_vm.selectProtocolTypeList[index]].length > 0 &&
      _vm.protocolInfo[_vm.selectProtocolTypeList[index]].length > 1) ? _c('div', {
      staticClass: "row step-content tags"
    }, [_c('div', {
      staticClass: "col-sm-10 col-md-offset-1"
    }, _vm._l((_vm.supplierProtocolRule[_vm.selectProtocolTypeList[index]]), function(tag, tagIndex) {
      return _c('v-tag', {
        key: tag.ruleName,
        staticClass: "tag",
        attrs: {
          "type": 'success',
          "close-transition": false,
          "closable": true
        },
        on: {
          "close": function($event) {
            _vm.handleTagClose(tagIndex, _vm.selectProtocolTypeList[index])
          }
        }
      }, [_vm._v("\n                        " + _vm._s(tag.ruleName) + "\n                    ")])
    }))]) : _vm._e()])
  })) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1499fcd7","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/supplierProtocol.vue
// module id = 544
// module chunks = 0